'use strict';

var React = require('react');

var SvgTransferOutIcon = function SvgTransferOutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.25a.75.75 0 0 0-1.5 0v11.5a.75.75 0 0 0 1.5 0v-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10.75a.75.75 0 0 0 0-1.5h-6.94l1.72-1.72a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06-1.06l-1.72-1.72h6.94Z"
  }));
};
SvgTransferOutIcon.displayName = "TransferOutIcon";

exports.SvgTransferOutIcon = SvgTransferOutIcon;
